var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivacyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#192235"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4242 19.2668C27.4242 23.3418 24.4659 27.1585 20.4242 28.2752C20.1492 28.3502 19.8492 28.3502 19.5742 28.2752C15.5325 27.1585 12.5742 23.3418 12.5742 19.2668V15.6085C12.5742 14.9252 13.0909 14.1502 13.7326 13.8918L18.3742 11.9918C19.4159 11.5668 20.5909 11.5668 21.6325 11.9918L26.2742 13.8918C26.9076 14.1502 27.4326 14.9252 27.4326 15.6085L27.4242 19.2668Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0007 20.4171C20.9211 20.4171 21.6673 19.6709 21.6673 18.7504C21.6673 17.8299 20.9211 17.0837 20.0007 17.0837C19.0802 17.0837 18.334 17.8299 18.334 18.7504C18.334 19.6709 19.0802 20.4171 20.0007 20.4171Z",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20.417V22.917",
    stroke: "white",
    strokeWidth: 1.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyIcon);
export default __webpack_public_path__ + "static/media/privacy_icon.ead4d16f9f6785e35620b314262d3478.svg";
export { ForwardRef as ReactComponent };